export default __webpack_public_path__ + "static/news-35fbdae9f142baf34387d04a7fc99487.png";